// TEST
console.log("content script working");

// BODY

// Show More Content
const moreContent = document.querySelector(".show-more");

moreContent.insertAdjacentHTML(
  "afterbegin",
  `
   <!-- MORE CONTENT -->
    <section class="more-content">
        <div class="category">
            <h3>MORE POETRY</h3>
            <ul>
                <li>Rhymes</li>
                <li>Verse</li>
                <li>Songs</li>
                <li>Lyrics</li>
            </ul>
        </div>
        <div class="container">
            <div class="flexbox">
                <!-- Poetry | Don't say it never -->
                <a href="./dontsayit.html">
                    <div class="post">
                        <div class="post-banner">
                            <p class="category-tag rhymes">Rhymes</p>
                            <img class="banner-img" src="../../images/orange_sunrise.webp"
                                alt="Illustration of an orange sunrise">
                        </div>
                        <div class="post-body">
                            <h2 class="post-title">Don't say it never</h2>
                            <p class="post-description">
                                From the dark into the grey, out comes the orange. <br>
                                Behind the side hides. <br>
                                Blue as the world awakens. <br>
                                They shine bright in the day. <br>
                                I never thought this day would come. <br>
                                I wish this could go on forever...
                            </p>
                            <p class="hashtags">#neverendingday #endlessday #daywithoutend</p>
                        </div>
                    </div>
                </a>
                <!-- Poetry | Dreaming -->
                <a href="../poetry/dreaming.html">
                    <div class="post">
                        <div class="post-banner">
                            <p class="category-tag verse">Verse</p>
                            <img class="banner-img" src='../../images/dreaming.webp'
                                alt='Canvas of dreaming while sleeping'>
                        </div>
                        <div class="post-body">
                            <h2 class="post-title">Dreaming</h2>
                            <p class="post-description">
                                In the silence of what the mind wants to think, <br>
                                It is powerful. <br>
                                Holds all emotion, <br>
                                Sends the perfect feeling for the heart to reveal, <br>
                                However, it is only a thought. <br>
                                As the sound enters the quietness... <br>
                            </p>
                            <p class="hashtags">#sleepingbeauty #dreamer</p>
                        </div>
                    </div>
                </a>
                <!-- Poetry | Love Overdue -->
                <a href="../poetry/loveoverdue.html">
                    <div class="post">
                        <div class="post-banner">
                            <i class="fa-solid fa-bookmark bookmark-tag"></i>
                            <p class="category-tag song">Song</p>
                            <img class="banner-img" src='../../images/fallen.webp'
                                alt='Fallen rose on sheet music'>
                        </div>
                        <div class="post-body">
                            <h2 class="post-title">Love Overdue</h2>
                            <p class="post-description">
                                You only need to listen once, <br>
                                Because I won’t say it to you twice. <br>
                                I won’t either stop or rewind. <br>
                                Because I’m going to give it to you so nice, <br>
                                I better make myself clear. <br>
                                This is the only thing I fear. <br>
                                Baby, I think we’ve been here before. <br>
                                It’s so hard to ignore... <br>
                            </p>
                            <p class="hashtags">#relationships #breakups</p>
                        </div>
                    </div>
                </a>
                <!-- Poetry | Disband Love -->
                <a href="../poetry/disbandlove.html">
                    <div class="post">
                        <div class="post-banner">
                            <i class="fa-solid fa-bookmark bookmark-tag"></i>
                            <p class="category-tag verse">Verse</p>
                            <img class="banner-img" src="../../images/disbandlove.webp"
                                alt="Illustration of the words disband love and break up">
                        </div>
                        <div class="post-body">
                            <h2 class="post-title">Disband Love</h2>
                            <p class="post-description">
                                As I stood staring at those words, <br>
                                I began to think about the way <br>
                                I felt before my heart broke. <br>
                                I never knew what love meant. <br>
                                I was afraid of not living up to what <br>
                                love is supposed to be? <br>
                            </p>
                            <p class="hashtags">#breakup #heartache #relationships</p>
                        </div>
                    </div>
                </a>

            </div>
        </div>
    </section>

    `
);
